import { UnicodeEntity } from '@mews/enums';
import { useAvailabilityBlockInfo } from '../../availabilityBlock/utils/useAvailabilityBlockInfo';
import { ModalLink } from '../../../components';

interface AvailabilityBlockLinkNameProps {
    availabilityBlockId: string;
}

export const AvailabilityBlockLinkName: React.FC<AvailabilityBlockLinkNameProps> = ({ availabilityBlockId }) => {
    const { availabilityBlock, url } = useAvailabilityBlockInfo(availabilityBlockId);

    return availabilityBlock?.name && url ? (
        <ModalLink url={url} data-test-availability-block-link={availabilityBlockId}>
            {availabilityBlock.name}
        </ModalLink>
    ) : (
        <>{UnicodeEntity.Dash}</>
    );
};
